/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useRef, useEffect,
} from 'react';
import Checkbox from 'react-custom-checkbox';
import moment from 'moment';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../redux/helper/CreateQuery';
import { removeLastComma } from '../../redux/helper/RemoveComma';

function FilterModal({
    close, setFilter, Filter, handleFetch, setfilterUrl, selected, setselected,
}) {
    // const order_Status = {
    //     Draft: 0,
    //     Pending: 1,
    //     InProcess: 2,
    //     'ApprovedOut for delivery': 3,
    //     'Partially delivered': 4,
    //     Deliverd: 5,
    //     Completed: 6,
    //     Cancelled: 7,
    // };
    const order_status = {
        0: 'Draft',
        1: 'Pending',
        2: 'InProcess',
        3: 'Approved',
        4: 'Out for delivery',
        5: 'Partially Delivered',
        6: 'Deliverd',
        7: 'Completed',
        8: 'Rejected',
    };
    const [selectedType, setselectedType] = useState('order_type');
    const getObjectUrl = () => {
        let final = '';
        Filter.order_status.length > 0 && Filter.order_status.map((val) => {
            final += `${val},`;
        });
        return removeLastComma(final);
    };
    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length !== 0) { final += `&status=9&order_type=${createUrl(Filter[key])}`; }

                break;
            // case 'order_status':
            //     if (Filter[key].length !== 0) {
            //         final += `&status=${getObjectUrl()}`;
            //     }
            //     // else {
            //     //     final += '&status=3,4,5,6,7,8';
            //     // }
            //     break;
            case 'type':
                if (Filter[key].length !== 0) { final += `&status=9&type=${createUrl(Filter[key])}`; }
                break;
            case 'order_category':
                if (Filter[key].length !== 0) { final += `&status=9&order_category=${createUrl(Filter[key])}`; }
                break;
            default: break;
            }
        });
        handleFetch(final);
        setfilterUrl(final);
        return final;
    };

    const handleClear = () => {
        setFilter({
            order_type: [],
            order_status: [],
            type: [],
            order_category: [],
        });
        setfilterUrl('');
        handleFetch();
    };
    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    const ref = useRef();
    const ref1 = useRef();
    const [toggle, settoggle] = useState(toggleState);
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setTimeout(() => {
                    settoggle((prevState) => ({
                        ...prevState,
                        start_date: false,
                        end_date: false,
                    }));
                }, 500);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
    }, [ref]);
    const AddToSelect = (item, type) => {
        const arr = [...selected[type]];
        const index = arr.indexOf(item);
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state);
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };
    return (
        <div
            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
        >
            <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                    Filter
                </h5>
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="/images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => close(false)}
                />
            </div>
            <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                <div className="flex items-start">
                    <ul className="nav nav-pills flex active flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                        <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('order_type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-priceranje"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-pricetab"
                                role="tab"
                                aria-controls="pills-price"
                                aria-selected="true"
                                data-testid="order-type"
                            >
                                Order Type
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('type')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'type' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                                data-testid="type-order"
                            >
                                Type
                            </a>
                        </li>
                        <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('order_category')}>
                            <a
                                href="javascript:void(0)"
                                className={`block text-base font-semibold ${selectedType === 'order_category' ? 'nav-link active' : ''} text-[#AAA6AF] order relative w-full`}
                                id="pills-categories"
                                data-bs-toggle="pill"
                                data-bs-target="#pillcategorie"
                                role="tab"
                                aria-controls="pillcategorie"
                                aria-selected="false"
                                data-testid="order-category"
                            >
                                Order Category
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content w-[70%] h-[300px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                        <div className={`tab-pane fade ${selectedType === 'order_type' ? 'show active' : ''} px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                            <div className="relative">
                                <div className="cursor-pointer">
                                    <div className="relative">
                                        <div className="cursor-pointer">

                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'TRADE')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('TRADE') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type?.includes('TRADE')}
                                                    borderColor={`${Filter.order_type?.includes('TRADE') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn1" data-testid="trade" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trade Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Trade EUB')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Trade EUB') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Trade EUB')}
                                                    borderColor={`${Filter.order_type.includes('Trade EUB') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="trade-eub" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trade EUB Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Domestic')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Domestic') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Domestic')}
                                                    borderColor={`${Filter.order_type.includes('Domestic') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="domestic" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Domestic Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Demo')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Demo') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Demo')}
                                                    borderColor={`${Filter.order_type.includes('Demo') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="demo" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Demo Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Free Service')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Free Service') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Free Service')}
                                                    borderColor={`${Filter.order_type.includes('Free Service') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="free-service" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Free Service Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Free Samples')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Free Samples') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Free Samples')}
                                                    borderColor={`${Filter.order_type.includes('Free Samples') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="free-samples" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Free Samples Order</label>
                                            </div>
                                            <div
                                                className="relative flex items-center mb-3"
                                                onClick={() => HandleFilter('order_type', 'Free Replacement')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes('Free Replacement') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.order_type.includes('Free Replacement')}
                                                    borderColor={`${Filter.order_type.includes('Free Replacement') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="free-replacement" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Free Replacement Order</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade${selectedType === 'type' ? 'show active' : ''} px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                            <div className="cursor-pointer">
                                <div
                                    className="relative flex items-center"
                                    onClick={() => HandleFilter('type', 'MIP')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('MIP') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.type.includes('MIP')}
                                        borderColor={`${Filter.type.includes('MIP') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn11" data-testid="mip-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">MIP</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px]"
                                    onClick={() => HandleFilter('type', 'HIP')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.type?.includes('HIP') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.type.includes('HIP')}
                                        borderColor={`${Filter.type.includes('HIP') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="mn12" data-testid="hip-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">HIP</label>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane fade ${selectedType === 'order_category' ? 'show active' : ''} px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                            <div className="cursor-pointer">
                                <div
                                    className="relative flex items-center"
                                    onClick={() => HandleFilter('order_category', 'CONSUMABLES')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('CONSUMABLES') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('CONSUMABLES')}
                                        borderColor={`${Filter.order_category.includes('CONSUMABLES') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs2" data-testid="consumable-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Consumables</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px] mb-3"
                                    onClick={() => HandleFilter('order_category', 'EQUIPMENTS/SGP')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('EQUIPMENTS/SGP') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('EQUIPMENTS/SGP')}
                                        borderColor={`${Filter.order_category.includes('EQUIPMENTS/SGP') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs3" data-testid="equipment-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Equipment/Spares</label>
                                </div>
                                <div
                                    className="relative flex items-center mt-[14px] mb-3"
                                    onClick={() => HandleFilter('order_category', 'MnR')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('MnR') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('MnR')}
                                        borderColor={`${Filter.order_category.includes('MnR') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs3" data-testid="equipment-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">MnR</label>
                                </div>
                                <div
                                    className="relative flex items-center"
                                    onClick={() => HandleFilter('order_category', 'TRADING')}
                                >
                                    <Checkbox
                                        icon={
                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_category?.includes('TRADING') ? '#555259' : ''}` }} />
                                        }
                                        name="my-input"
                                        className="cursor-pointer"
                                        checked={Filter.order_category.includes('TRADING')}
                                        borderColor={`${Filter.order_category.includes('TRADING') ? '#B8C5DC' : '#555259'}`}
                                        style={{ cursor: 'pointer' }}
                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                    />
                                    <label htmlFor="xs4" data-testid="trading-order" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">Trading</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full">
                    <div className="pt-3 flex justify-end w-[30%] mr-5">
                        <button
                            onClick={() => handleClear()}
                            type="button"
                            className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            Clear Filter
                        </button>
                    </div>
                    <div className="pt-3 flex justify-end w-[70%]">
                        <button
                            onClick={() => generateUrl()}
                            type="button"
                            className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            data-testid="apply-btn"
                        >
                            Apply Filter
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
